module.exports = {"helmetTitle":"Veloe - Contatos","title":"Contatos","subtitle":"Deixe seus contatos atualizados. Mas fique tranquilo: não vamos mandar corrente nem ligar o tempo todo. :)","modalTitle":"Pronto! A gente já salvou suas alterações. ;)","modaTitleError":"Foi Mal!","modaTextError":"Notamos que existe uma inconsistência nos dados de cadastro que você nos passou.  Por Favor, verifique e tente novamente."}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/EditContactData/data.json
// module id = 1729
// module chunks = 0